import React, { Component } from "react";
import {
  Input,
  Button,
  Form,
  InputNumber,
  Radio,
  Select,
  Divider,
  message,
  DatePicker,
  Upload,
} from "antd";
import PhoneInput, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import dayjs from "dayjs";
import { FaAngleLeft, FaSave, FaTimes } from "react-icons/fa";
import { Link, withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { EditCustomer, GetCustomerByNIN } from "../../network/customer.network";
import { AiOutlineFileSearch } from "react-icons/ai";
import { SyncOutlined, FileImageOutlined } from "@ant-design/icons";
import { RegisterCustomer } from "../../network/auth.network";
import {
  AddOrUpdateFinancingRequestForCustomer,
  AddOrder,
  UploadOrderFile,
} from "../../network/request.network";
import { FaCloudUploadAlt, FaDownload, FaEye, FaFilePdf } from "react-icons/fa";
import CarModal from "../CarModal/CarModal";
import "./Customerdata.scss";
const { Option } = Select;
const dateBefore8Years = dayjs().subtract(8, "year").format("YYYY-MM-DD");

const provinceData = ["Zhejiang", "Jiangsu"];
const cityData = {
  Zhejiang: ["Hangzhou", "Ningbo", "Wenzhou"],
  Jiangsu: ["Nanjing", "Suzhou", "Zhenjiang"],
};

class Customerdata extends Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.formRef = React.createRef();
  }
  state = {
    step: 2,
    numberVal: "",
    activeList: "عسكري",
    provinceData: ["عسكري", "Jiangsu"],
    cityData: {
      عسكري: ["رقيب", "ملازم", "عقيد"],
      Jiangsu: ["Nanjing", "Suzhou", "Zhenjiang"],
    },
    FinanceRequestFiles: [],
    FinanceRequestFilesUploaded: [],
    FinanceRequestFilesNotUploaded: [],
    customerNID: "",
    typing: false,
    typingTimeout: 0,
    iconLoading: false,
    detailsModal: false,
    JobTitlesState: [],
    custId: 0,
    jobTitle: null,
    checkJobTitle: false,
    btnSaveLoading: false,
    IsSupport: 0,
    isMonthlyCommitment: false,
    IdentityId: "",
    OrderFileIds: [],
  };

  //   {
  //     "CarModelId": 1,
  //     "CarColorId": 2,
  //     "BankId": 1,
  //     "Salary": 5000,
  //     "SalaryBankId": 1,
  //     "IsSupported": false,
  //     "SupportValue": null,
  //     "HaveACommitment": false,
  //     "MonthlyCommitmentValue": null,
  //     "CommitmentPartyName": null,
  //     "BirthDate": "2000-01-01", //date
  //     "IdNumber": "14785236987456", //string
  //     "IsResident": true, //bool
  //     "ResidentName": null, //string
  //     "WorkAddress": null, //string
  //     "HomeAddress": null, //string
  //     "EmployerId": null, //long
  //     "OrderFileIds": [
  //         8,
  //         9,
  //         10,
  //         11
  //     ]
  // }

  componentDidMount() {
    this.handelAllFileUploadOrNot();

    this.searchCustomerNID({
      target: { value: this.props.NationalIdentityNumber },
    });
    if (
      this.props.clientData != null &&
      Object.keys(this.props.clientData).length > 0
    ) {
      const { clientData } = this.props;
      this.formRef.current.setFieldsValue({
        customerID: clientData.NationalIdentityNumber,
        ResidentName: clientData.AspNetUsers.FullName,
        customerEmail: clientData.AspNetUsers.Email,
        customerPhone:
          clientData.AspNetUsers.PhoneKey + clientData.AspNetUsers.PhoneNumber,
        customerArea: clientData.City?.Id
          ? clientData.City?.Id
          : clientData.CityId,
        CityId: clientData?.CityId,
        WorkCityId: clientData?.WorkCityId,
        SupportValue: clientData?.SupportValue,
        customerWorkName: clientData.EmployerName,
        ResidentSalary: clientData.Salary,
        customerAlt: clientData.HousingAllowance,
        customerTrans: clientData.TransportationAllowance,
        customerGender: clientData.Gender.Id,
        BankId: clientData.Bank.Id,
        CarColorId: clientData.CarColorId,
        // BirthDate: dayjs(clientData?.BirthDate).format("YYYY/M/D"),
        support: clientData.IsSupported ? 1 : 0,
        EmployerId: clientData.EmployerId,
      });
      this.setState({
        custId: clientData.Id,
        IdentityId: clientData.IdentityId,
      });
    }
  }

  searchCustomerNID = (evt) => {
    var searchText = evt.target.value;
    searchText =
      this.formRef.current.getFieldValue("customerID") || evt.target.value;
    if (searchText) {
      this.setState({ iconLoading: true });
      GetCustomerByNIN(
        searchText,
        (res) => {
          let data = res.data?.model;
          this.setState({
            iconLoading: false,
            numberVal:
              data?.AspNetUsers?.PhoneKey + data?.AspNetUsers?.PhoneNumber,
          });
          // console.log(
          //   dayjs(data?.BirthDate, "YYYY-MM-DD"),
          //   "dayjs(data?.BirthDate)"
          // );
          this.formRef.current.setFieldsValue({
            customerID: data?.NationalIdentityNumber,
            ResidentName: data?.AspNetUsers?.FullName,
            customerEmail: data?.AspNetUsers?.Email,
            customerPhone:
              data?.AspNetUsers?.PhoneKey + data?.AspNetUsers?.PhoneNumber,
            customerArea: data?.CityId,
            CityId: data?.CityId,
            WorkCityId: data?.WorkCityId,
            SupportValue: data?.SupportValue,
            customerWorkName: data?.EmployerName,
            ResidentSalary: data?.Salary,
            customerAlt: data?.HousingAllowance,
            customerTrans: data?.TransportationAllowance,
            customerGender: data?.GenderId,
            CarColorId: data.CarColorId,
            BankId: data?.BankId,
            WorkAddress: data?.WorkAddress,
            HomeAddress: data?.HomeAddress,
            // BirthDate: dayjs(data?.BirthDate).isValid()
            //   ? dayjs(data?.BirthDate, "YYYY-MM-DD")
            //   : undefined,
            support: data?.IsSupported ? 1 : 0,
            SuportAmount: data?.SuportAmount,
            EmployerId: data?.EmployerId,
          });
          this.setState({
            custId: data.Id,
            IdentityId: data?.IdentityId,
            checkJobTitle: false,
            IsSupport: !!data?.IsSupported,
          });
          this.setState({
            employerTitle: data.EmployerId,
          });
        },
        (error) => {
          message.info("لم يتم العثور على العميل في النظام");
          this.setState({ iconLoading: false });
        }
      );
    }
    // }, 5000);
  };

  handelAllFileUploadOrNot = () => {
    const { FinanceRequestFiles } = this.state;
    const { FileTypes } = this.props;
    if (FileTypes) {
      this.setState({ tableLoading: false });
      let result = FileTypes.filter(
        (o1) => !FinanceRequestFiles.some((o2) => o1.Id === o2?.FileType?.Id)
      );
      this.setState({
        FinanceRequestFilesNotUploaded: result,
        FinanceRequestFilesUploaded: FinanceRequestFiles,
      });
    } else {
      setTimeout(() => {
        this.handelAllFileUploadOrNot();
      }, 1000);
    }
  };

  changeCustomerNID = (event) => {
    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);
    }

    this.setState({
      customerNID: event.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        this.sendToParent(this.state.customerNID);
      }, 5000),
    });
  };
  //-moz-appearance: textfield;
  handleEmployerChange = (value) => {
    const JobTitlesState = this.props?.JobTitles.filter(
      (title) => title.EmployerId === value
    );
    this.setState({ JobTitlesState, jobTitle: null, employerTitle: value });
    // if (value === null) this.setState({ checkJobTitle: true });
    // else this.setState({ checkJobTitle: false });
  };

  onTitleChange = (value) => {
    this.setState({ jobTitle: value });
  };

  setDetailsModal = (value) => {
    this.setState({ detailsModal: value });
  };

  handelREg = (values) => {
    // console.log(values)
  };
  onFinishFailed = (errorInfo) => {
    console.log(errorInfo, "errorInfoerrorInfoerrorInfo");
    // if (this.state.jobTitle === null) this.setState({ checkJobTitle: true });
    // else this.setState({ checkJobTitle: false });
    // console.log(errorInfo)
  };

  handelAddFile = (data, fileInfo) => {
    console.log(data, "filefilefile");
    console.log(fileInfo, "fileInfo");
    console.log(data?.status, "data?.statusdata?.status");
    if (data?.status === "removed") {
      console.log(this.state.OrderFileIds, "this.state.OrderFileIds");
      const filterFiles = this.state.OrderFileIds?.filter(
        (s) => s?.fileId !== fileInfo?.Id
      );
      console.log(filterFiles, "filterFilesfilterFiles");
      this.setState({ OrderFileIds: filterFiles });
      return false;
    }
    let body = new FormData();
    body.append("FileTypeId", fileInfo?.Id);
    body.append("File", data);
    UploadOrderFile(
      body,
      (res) => {
        // message.success("تم التسجيل بنجاح");
        console.log(res?.data, "ressssss");
        const uploadFile = {
          fileId: fileInfo?.Id,
          requestFileId: res?.data?.model,
        };
        const OrderFileIdsList = [...this.state.OrderFileIds, uploadFile];
        // const OrderFileIdsList = [...this.state.OrderFileIds, res?.data?.model];
        // let unique = [...new Set(OrderFileIdsList)];
        this.setState({ OrderFileIds: OrderFileIdsList });
      },
      (err) => {
        console.log(err);
      }
    );
  };

  handelRemoveFile = (data, fileInfo) => {
    console.log(this.state.OrderFileIds, "this.state.OrderFileIds");
    const filterFiles = this.state.OrderFileIds?.filter(
      (s) => s?.fileId !== fileInfo?.Id
    );
    console.log(filterFiles, "filterFilesfilterFiles");
    this.setState({ OrderFileIds: filterFiles });
  };

  dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  onFinish = (values) => {
    const { setLoadingSendBtn, currentUser } = this.props;
    const {
      location: { state },
    } = this.props;
    console.log(values, "sdfsadffds");
    // if (this.state.employerTitle === null)
    //   this.setState({ checkJobTitle: true });
    // else this.setState({ checkJobTitle: false });
    this.setState({ btnSaveLoading: true });
    setLoadingSendBtn(true);
    const phoneNumber = parsePhoneNumber(values?.customerPhone || "");

    let body = {
      CarModelId: state?.mainData?.Id,
      CarColorId: values?.CarColorId,
      BankId: values?.BankId,
      SalaryBankId: values?.SalaryBankId,
      SupportValue: values?.SupportValue,
      MonthlyCommitmentValue: values?.MonthlyCommitmentValue,
      CommitmentPartyName: values?.CommitmentPartyName,
      IsResident: values?.IsResident ? true : false,
      // BirthDate: dayjs(values.BirthDate?.toDate?.().toString()).format(
      //   "YYYY-MM-DD"
      // ),
      IdNumber: values?.customerID,
      ResidentName: values?.ResidentName,
      Salary: values?.ResidentSalary,
      WorkAddress: values?.WorkAddress,
      HomeAddress: values?.HomeAddress,
      EmployerId: values?.EmployerId,
      IsSupported: values?.support ? true : false,
      HaveACommitment: values?.isMonthlyCommitment ? true : false,
      OrderFileIds:
        this.state?.OrderFileIds?.map((s) => s?.requestFileId) || [],
      // Email: values?.customerEmail,
      // PhoneNumber: phoneNumber?.nationalNumber,
      // PhoneKey: phoneNumber?.countryCallingCode,

      // EmployerName: values?.customerWorkName,
      // CityId: values?.CityId,
      // WorkCityId: values?.WorkCityId,
      // IsSupported: values?.support ? true : false,
      // JobTitleId: this.state?.jobTitle,
      // EmployerId: this.state?.employerTitle,
      // GenderId: values?.customerGender,
      // PhoneNumber: phoneNumber.nationalNumber,
      // PhoneKey: phoneNumber.countryCallingCode,
      // Email: values.customerEmail,
      // FullName: values.ResidentName,
      // Password: "123456789",
      // ConfirmPassword: "123456789",
      // ProfileImage: null,
      // CarColorId: values?.CarColorId,

      // Id: this.state.custId,
      // IdentityId: this.state.IdentityId,
    };
    if (currentUser) {
      let userBody = {
        // Id: 0,
        // CustomerId: currentUser?.Id,
        // FinanceRequestSourceId: 2,
        ...body,

        // CarFinancingRequest: {
        //   CarModelId: values?.CarModelId || 1,
        //   CarColorId: values?.CarColorId,
        // },
      };
      AddOrder(
        userBody,
        (res) => {
          message.success("تم التسجيل بنجاح");
          this.setState({ btnSaveLoading: false });
          setLoadingSendBtn(false);

          setTimeout(() => {
            this.props.history.push({
              pathname: "/done",
              state: { orderId: res?.data?.model?.Id },
            });
          }, 500);
        },
        (err) => {
          //console.log(err)
          // message.success("تم التسجيل بنجاح");
          // this.props.history.push("/signin");
          this.setState({ btnSaveLoading: false });
          setLoadingSendBtn(false);
        }
      );
      return false;
    }
    RegisterCustomer(
      body,
      (res) => {
        let userBody = {
          Id: 0,
          CustomerId: res?.data?.model?.Id,
          FinanceRequestSourceId: 2,
          CarFinancingRequest: {
            CarModelId: values?.CarModelId || 1,
            CarColorId: values?.CarColorId,
          },
        };
        AddOrUpdateFinancingRequestForCustomer(
          userBody,
          (res) => {
            message.success("تم التسجيل بنجاح");
            this.setState({ btnSaveLoading: false });
            setLoadingSendBtn(false);

            setTimeout(() => {
              this.props.history.push("/done");
            }, 500);
          },
          (err) => {
            //console.log(err)
            // message.success("تم التسجيل بنجاح");
            // this.props.history.push("/signin");
            this.setState({ btnSaveLoading: false });
            setLoadingSendBtn(false);
          }
        );
        // message.success("تم التسجيل بنجاح");
        // this.props.history.push({
        //   pathname: "/phone-verification",
        //   state: {
        //     PhoneKey:
        //       "+" + parsePhoneNumber(values?.PhoneNumber)?.countryCallingCode,
        //     PhoneNumber: parsePhoneNumber(values?.PhoneNumber)?.nationalNumber,
        //     email: body.Email,
        //     status: 1,
        //   },
        // });
        this.setState({ btnSaveLoading: false });
      },
      (error) => {
        setLoadingSendBtn(false);

        if (error.Code === 26) message.error("هذا العميل موجود بالفعل");
        else if (error.Code === 24)
          message.error("البريد الإلكترونى موجود لدى عميل آخر");
        else if (error.Code === 4 || error.Code === 22)
          message.error("رقم الهاتف موجود بالفعل لعميل آخر");
        this.setState({ btnSaveLoading: false });
      }
    );

    return false;
    if (this.state.employerTitle === null)
      this.setState({ checkJobTitle: true });
    else this.setState({ checkJobTitle: false });
    if (this.props.showAdd) {
      this.setState({ btnSaveLoading: true });
      const phoneNumber = parsePhoneNumber(values.customerPhone || "");
      let body = {
        NationalIdentityNumber: values.customerID,
        EmployerName: values.customerWorkName,
        BirthDate: dayjs("" + values.BirthDate, "YYYY/M/D").format(
          "YYYY-MM-DD"
        ),
        Salary: values.ResidentSalary,
        // HousingAllowance: values.customerAlt,
        // TransportationAllowance: values.customerTrans,
        CityId: values?.CityId,
        WorkCityId: values?.WorkCityId,
        IsSupported: values.support ? true : false,
        IsResident: values?.IsResident ? true : false,
        JobTitleId: this.state.jobTitle,
        EmployerId: this.state.employerTitle,
        GenderId: values.customerGender,
        BankId: values.BankId,
        PhoneNumber: phoneNumber.nationalNumber,
        PhoneKey: phoneNumber.countryCallingCode,
        Email: values.customerEmail,
        FullName: values.ResidentName,
        Password: values?.Password,
        ConfirmPassword: values?.ConfirmPassword,
        ProfileImage: null,
        SupportValue: values?.SupportValue,
        CarColorId: values?.CarColorId,

        // Id: this.state.custId,
        // IdentityId: this.state.IdentityId,
      };
      EditCustomer(
        body,
        (res) => {
          message.success("تم تعديل العميل بنجاح");
          this.setState({ btnSaveLoading: false });
          this.props.handelShowInfo(res.data.model);
        },
        (error) => {
          if (error.Code === 26) message.error("هذا العميل موجود بالفعل");
          else if (error.Code === 24)
            message.error("البريد الإلكترونى موجود لدى عميل آخر");
          else if (error.Code === 4)
            message.error("رقم الهاتف موجود بالفعل لعميل آخر");
          this.setState({ btnSaveLoading: false });
        }
      );
    } else
      this.props.submitForm(values, [
        {
          jobTitle: this.state.jobTitle,
          employerTitle: this.state.employerTitle,
          custID: this.state.custId,
          IdentityId: this.state.IdentityId,
        },
      ]);
  };

  render() {
    const {
      provinceData,
      cityData,
      activeList,
      iconLoading,
      detailsModal,
      employerTitle,
      jobTitle,
      JobTitlesState,
      IsSupport,
      FinanceRequestFilesUploaded,
      FinanceRequestFilesNotUploaded,
    } = this.state;
    const { showAdd, submitForm, FileTypes } = this.props;
    const {
      location: { state },
    } = this.props;

    console.log(state, "FileTypesFileTypesFileTypesFileTypes");
    return (
      <div className="finance-tab-content">
        {/* {!showAdd && <h2 className="tab-title">بيانات العميل</h2>} */}
        {!showAdd && <h2 className="tab-title">طلب سيارة</h2>}
        <Form
          initialValues={{ customerWork: employerTitle && "ccc" }}
          className="form-add-content"
          layout="vertical"
          name="nest-messages"
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
          id="orderForm0"
          ref={this.formRef}
        >
          <div className="form-content">
            <Divider
              className="divider-style"
              orientation="right"
              onClick={() => {
                this.setState({ detailsModal: true });
              }}
            >
              بيانات السياره
              <Button type="primary" style={{ marginInlineStart: 12 }}>
                اظهار بيانات السياره
              </Button>
            </Divider>
            <Form.Item
              label="موديل السياره"
              name="carBrand"
              className="input-holder"
            >
              <Input
                placeholder=""
                defaultValue={state?.mainData?.CarBrand?.NameLT}
                disabled
              />
            </Form.Item>
            <Form.Item
              label="نوع السياره"
              name="carTybe"
              className="input-holder"
            >
              <Input
                placeholder=""
                defaultValue={state?.mainData?.NameLT}
                disabled
              />
            </Form.Item>
            <Form.Item
              label="اللون المفضل"
              name="CarColorId"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك حدد اللون",
                },
              ]}
            >
              <Select>
                {this.props.CarColors?.map((color) => {
                  return (
                    <Select.Option key={color.Id} value={color.Id}>
                      {color.NameLT}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label="البنك"
              name="BankId"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك حدد البنك",
                },
              ]}
            >
              <Select>
                {this.props.Banks.map((bank) => {
                  return (
                    <Select.Option key={bank?.Id} value={bank?.Id}>
                      {bank?.NameLT}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Divider className="divider-style" orientation="right">
              بيانات شخصيه
            </Divider>
            <Form.Item
              label="رقم هوية العميل"
              name="customerID"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك ادخل رقم هوية العميل",
                },
                {
                  len: 10,
                  message: "رقم الهوية يتكون من 10 أرقام",
                },
              ]}
            >
              <Input
                // disabled
                placeholder=""
                className="search-addon-user"
                addonAfter={
                  !iconLoading ? (
                    <AiOutlineFileSearch
                      onClick={(evt) => this.searchCustomerNID(evt)}
                    />
                  ) : (
                    <SyncOutlined spin />
                  )
                }
                onPressEnter={(evt) => this.searchCustomerNID(evt)}
              />
            </Form.Item>
            <Form.Item
              label="اسم العميل"
              name="ResidentName"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك ادخل اسم العميل",
                },
              ]}
            >
              <Input placeholder="" />
            </Form.Item>
            <Form.Item
              label="البريد الالكتروني"
              name="customerEmail"
              className="input-holder"
              rules={[
                {
                  type: "email",
                  message: "من فضلك ادخل بريد إلكتروني صحيح",
                },
                {
                  required: true,
                  message: "من فضلك ادخل البريد الإلكتروني",
                },
                // {
                //   pattern: new RegExp('[a-zA-Z0-9]{0,}([.]?[a-zA-Z0-9]{1,})[@](gmail|hotmail|outlook)'),
                //   message: 'من فضلك ادخل بريد إلكتروني منتهياً ب gmail - outlook - hotmail',
                // }
              ]}
            >
              <Input placeholder="" />
            </Form.Item>
            <Form.Item
              label="رقم الجوال"
              name="customerPhone"
              className="input-holder"
              rules={[
                // {
                //   validator:this.testPhone,
                // }
                //   {
                //     required: true,
                //     message: 'من فضلك ادخل رقم الجوال',
                //   },
                //   {
                //     len:13,
                //     message: "رقم الجوال غير صحيح",
                // },
                {
                  validator(_, value) {
                    let phoneValid = isValidPhoneNumber(value || "");
                    if (!value)
                      return Promise.reject("من فضلك ادخل رقم الجوال");
                    else if (!phoneValid)
                      return Promise.reject("رقم الجوال غير صحيح");
                    else return Promise.resolve();
                  },
                },
              ]}
            >
              <PhoneInput
                international
                countryCallingCodeEditable={false}
                // countryOption ={["SA"]}
                defaultCountry="SA"
                value={this.state.numberVal}
                //onChange={(val) =>this.setState({numberVal : val})}
              />
            </Form.Item>
            {/* <Form.Item
              label="تاريخ الميلاد"
              name="BirthDate"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك ادخل تاريخ الميلاد",
                },
              ]}
            >
              <DatePicker
                disabledDate={(d) => {
                  return !d || d?.isAfter(dateBefore8Years);
                }}
              />
            </Form.Item> */}
            <Form.Item
              label="الجنسيه"
              name="IsResident"
              className="input-holder"
            >
              <Radio.Group name="radiogroup" defaultValue={true}>
                <Radio value={false}>سعودي</Radio>
                <Radio value={true}>غير سعودي</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label="عنوان السكن"
              name="HomeAddress"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك حدد عنوان السكن",
                },
              ]}
            >
              <Input placeholder="" />
            </Form.Item>
            {/* <Form.Item
              label="المنطقة"
              name="customerArea"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك حدد منطقة العميل",
                },
              ]}
            >
              <Select>
                {this.props.Cities?.map((city) => {
                  return (
                    <Select.Option key={city.Id} value={city.Id}>
                      {city.NameLT}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item> */}
            <Divider className="divider-style" orientation="right">
              بيانات الوظيفه
            </Divider>
            <div>
              <Form.Item
                label=" جهة العمل"
                name="EmployerId"
                className="input-holder select-group-holder"
                style={{ marginBottom: "0px" }}
              >
                <Select>
                  {this.props.Employers?.map((emp) => {
                    return (
                      <Select.Option key={emp?.Id} value={emp?.Id}>
                        {emp?.NameLT}
                      </Select.Option>
                    );
                  })}
                </Select>

                {/* <Select
                  value={employerTitle}
                  onChange={this.handleEmployerChange}
                >
                  {this.props.Employers?.map((emp) => {
                    return (
                      <Select.Option key={emp.Id} value={emp.Id}>
                        {emp.NameLT}
                      </Select.Option>
                    );
                  })}
                </Select>
                <Divider style={{ height: 30 }} type="vertical" />
                <Select
                  value={jobTitle}
                  onChange={this.onTitleChange}
                  disabled={employerTitle == 2}
                >
                  {JobTitlesState.map((title) => {
                    return (
                      <Select.Option key={title.Id} value={title.Id}>
                        {title.NameLT}
                      </Select.Option>
                    );
                  })}
                </Select> */}
              </Form.Item>
              {/* {this.state.checkJobTitle && (
                <span
                  style={{
                    color: "#fe5252",
                    textAlign: "right",
                    marginTop: "-10px",
                  }}
                >
                  من فضلك حدد جهة العمل
                </span>
              )} */}
            </div>
            {/* <Form.Item
              label=" اسم جهة العمل"
              name="customerWorkName"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك ادخل اسم جهة العمل",
                },
              ]}
            >
              <Input placeholder="" />
            </Form.Item> */}
            {/* <Form.Item
              label="عنوان العمل"
              name="WorkCityId"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك حدد عنوان العمل",
                },
              ]}
            >
              <Select>
                {this.props.Cities?.map((city) => {
                  return (
                    <Select.Option key={city.Id} value={city.Id}>
                      {city.NameLT}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label="عنوان السكن"
              name="CityId"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك حدد عنوان السكن",
                },
              ]}
            >
              <Select>
                {this.props.Cities?.map((city) => {
                  return (
                    <Select.Option key={city.Id} value={city.Id}>
                      {city.NameLT}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item> */}

            <Form.Item
              label="عنوان العمل"
              name="WorkAddress"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك حدد عنوان العمل",
                },
              ]}
            >
              <Input placeholder="" />
            </Form.Item>
            <Form.Item
              label="بنك الراتب"
              name="SalaryBankId"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك حدد بنك الراتب",
                },
              ]}
            >
              <Select>
                {this.props.Banks.map((bank) => {
                  return (
                    <Select.Option key={bank?.Id} value={bank?.Id}>
                      {bank?.NameLT}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label="الراتب الاساسي"
              name="ResidentSalary"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك ادخل راتب العميل",
                },
              ]}
            >
              <InputNumber min={0} />
            </Form.Item>

            {/* <Form.Item
              label="بدل النقل"
              name="customerTrans"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك ادخل بدل النقل",
                },
              ]}
            >
              <InputNumber min={0} />
            </Form.Item> */}

            {/* <Form.Item
              label="نوع العميل"
              name="customerGender"
              className="input-holder"
              rules={[
                {
                  required: true,
                  message: "من فضلك حدد الجنس",
                },
              ]}
            >
              <Select>
                {this.props.Genders.map((gender) => {
                  return (
                    <Select.Option key={gender.Id} value={gender.Id}>
                      {gender.NameLT}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item> */}
            {/* <Form.Item
              label="مدعوم"
              name="support"
              className="input-holder"
              // rules={[
              //     {
              //       required: true,
              //       message: 'Please input customer phone',
              //     },
              //   ]}
            >
              <Radio.Group
                name="radiogroup"
                onChange={(e) => this.setState({ IsSupport: e.target.value })}
                defaultValue={1}
              >
                <Radio value={1}>نعم</Radio>
                <Radio value={0}>لا</Radio>
              </Radio.Group>
            </Form.Item> */}

            <Form.Item label="مدعوم" name="support" className="input-holder">
              <Radio.Group
                name="radiogroup"
                onChange={(e) => this.setState({ IsSupport: e.target.value })}
                value={IsSupport}
                defaultValue={0}
              >
                <Radio value={1}>نعم</Radio>
                <Radio value={0}>لا</Radio>
              </Radio.Group>
            </Form.Item>
            {this.state.IsSupport ? (
              <Form.Item
                label="قيمه الدعم"
                name="SupportValue"
                className="input-holder"
                rules={[
                  {
                    required: true,
                    message: "من فضلك ادخل قيمه الدعم",
                  },
                ]}
              >
                <Input type="number" placeholder="" />
              </Form.Item>
            ) : null}

            <Form.Item
              label="هل لديك التزامات شهرية ؟"
              name="isMonthlyCommitment"
              className="input-holder"
            >
              <Radio.Group
                name="radiogroup"
                onChange={(e) =>
                  this.setState({ isMonthlyCommitment: e.target.value })
                }
                value={IsSupport}
                defaultValue={0}
              >
                <Radio value={1}>نعم</Radio>
                <Radio value={0}>لا</Radio>
              </Radio.Group>
            </Form.Item>
            {this.state.isMonthlyCommitment ? (
              <>
                <Form.Item
                  label="قيمة الالتزام الشهرية"
                  name="MonthlyCommitmentValue"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك ادخل قيمه الالتزام",
                    },
                  ]}
                >
                  <Input type="number" placeholder="" />
                </Form.Item>
                <Form.Item
                  label="اسم جهة الالتزام"
                  name="CommitmentPartyName"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك ادخل اسم جهة الالتزام",
                    },
                  ]}
                >
                  <Input placeholder="" />
                </Form.Item>
              </>
            ) : null}
          </div>
          <Divider className="divider-style" orientation="right">
            المستندات
          </Divider>
          <div className="form-content pt-30 grid-perc">
            {FileTypes?.map((s) => (
              <Form.Item
                label={s.NameLT}
                name={s.Id}
                className="input-holder avatar-uploader-form-item"
                rules={[
                  {
                    required: !s.IsOptional,
                  },
                ]}
              >
                <Upload
                  name="avatar"
                  // listType='picture-card'
                  listType="picture"
                  maxCount={1}
                  className="avatar-uploader"
                  // showUploadList={false}
                  // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  customRequest={this.dummyRequest}
                  // beforeUpload={beforeUpload}

                  beforeUpload={(file) => this.handelAddFile(file, s)}
                  onRemove={(file) => this.handelRemoveFile(file, s)}
                >
                  <div className="btn-upload">
                    <div className="upload-btn-holder">
                      <div className="browse-file-content">
                        <FaCloudUploadAlt />
                        <div className="browse-file-text">
                          <p>قم بإسقاط الملفات هنا </p>
                          <span>
                            (
                            {s?.MimeType?.replace("application/", " ").replace(
                              "image/",
                              " "
                            )}
                            )
                          </span>
                        </div>
                      </div>
                      <h5 className="browse-file-p">أو تصفح الملفات</h5>
                    </div>
                  </div>
                </Upload>
              </Form.Item>
            ))}
          </div>
          <CarModal
            mainData={state?.mainData}
            open={detailsModal}
            setOpen={() => this.setDetailsModal()}
            hideBtn
          />

          {/* <div className="form-content pt-30 grid-perc d-none">
            {FinanceRequestFilesUploaded?.filter(
              (file) => file?.FileType?.IsCustomerFile === true
            )?.map((doc) => (
              <div className="docs-holder" key={doc.Id}>
                <h6 className="docs-title">{doc?.FileType?.NameLT}</h6>
                <div className="doc-body">
                  <div className="browse-file-content">
                    <FaFilePdf />
                    <div className="browse-file-text">
                      <p>
                        {doc?.FileType?.MimeType?.replace(
                          "application/",
                          " "
                        ).replace("image/", " ")}
                      </p>
                    </div>
                  </div>
                  <div className="doc-action">
                    <a href={doc.Path} target="_blank">
                      <FaEye style={{ color: "#f4cc26" }} />
                    </a>
                    <a href={doc.Path} target="_blank">
                      <FaDownload
                        style={{ color: "#0c74c2", margin: "0 14px" }}
                      />
                    </a>
                    <FaTimes
                      style={{ color: "#cc3524" }}
                      onClick={() =>
                        this.setState({
                          showDltModal: true,
                          docDltId: doc,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            ))}
            {FinanceRequestFilesNotUploaded?.filter(
              (file) => file.IsCustomerFile === true
            ).map((file) => (
              <Form.Item
                label={file.NameLT}
                name={file.Id}
                className="input-holder"
                rules={[
                  {
                    required: !file.IsOptional,
                  },
                ]}
              >
                <Upload
                  // listType="picture"
                  accept={file.MimeType}
                  maxCount={1}
                  // onChange={(data) => this.handelChangeImg(data, file)}
                  showUploadList={false}
                  beforeUpload={(data) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                      // console.log(data, "sadfsd")
                    };
                    return false;
                  }}
                >
                  <div className="btn-upload">
                    <div className="upload-btn-holder">
                      <div className="browse-file-content">
                        <FaCloudUploadAlt />
                        <div className="browse-file-text">
                          <p>قم بإسقاط الملفات هنا </p>
                          <span>
                            (
                            {file?.MimeType?.replace(
                              "application/",
                              " "
                            ).replace("image/", " ")}
                            )
                          </span>
                        </div>
                      </div>
                      <h5 className="browse-file-p">أو تصفح الملفات</h5>
                    </div>
                  </div>
                </Upload>
              </Form.Item>
            ))}
          </div> */}
          {showAdd && (
            <div className="form-add-btns">
              <Button
                type="primary"
                size="large"
                className="blue-btn xlg"
                icon={<FaSave />}
                htmlType="submit"
                loading={this.state.btnSaveLoading}
              >
                حفظ
              </Button>
              <Button
                type="primary"
                size="large"
                className="red-btn xlg"
                onClick={() => this.props.handelShowInfo(null)}
                icon={<FaTimes />}
              >
                الغاء
              </Button>
            </div>
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Cities: state.user.metaData?.Cities,
  Banks: state.user.metaData?.Banks,
  Genders: state.user.metaData?.Genders,
  Employers: state.user.metaData?.Employers,
  CarColors: state.user.metaData?.CarColors || [],
  currentUser: state.user.currentUser,
  NationalIdentityNumber: state.user.currentUser?.NationalIdentityNumber,
  JobTitles: state.user.metaData?.JobTitles || [],
  FileTypes: state.user.metaData.FileTypes || [],
});

const CustomerdataWithRouter = withRouter(Customerdata);
export default connect(mapStateToProps)(CustomerdataWithRouter);
